<script setup>
import { useI18n } from 'vue-i18n';
const props = defineProps({
  footer: { type: Boolean, default: false },
  page: { type: Number, required: true },
  totalPages: { type: Number, required: true },
  totalRows: { type: Number, required: true },
  visibleRows: { type: Number, required: true },
});

const emit = defineEmits(['changePage']);
const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-wrap items-center gap-3 text-sm text-lais-text-muted"
    :class="
      props.footer
        ? 'justify-end border-t border-lais-border-soft px-4 py-2'
        : 'justify-between'
    "
  >
    <span v-if="!props.footer">
      {{
        t('POST_SALE.PAGINATION.RESULTS', {
          visible: visibleRows,
          total: totalRows,
        })
      }}
    </span>
    <div class="flex items-center gap-2">
      <button
        type="button"
        class="rounded-lais px-3 py-2 font-semibold text-lais-text transition hover:bg-lais-bg-soft disabled:cursor-not-allowed disabled:opacity-50"
        :disabled="page <= 1"
        @click="emit('changePage', page - 1)"
      >
        {{ t('POST_SALE.PAGINATION.PREVIOUS') }}
      </button>
      <span>{{
        t('POST_SALE.PAGINATION.PAGE', { page, total: totalPages })
      }}</span>
      <button
        type="button"
        class="rounded-lais px-3 py-2 font-semibold text-lais-text transition hover:bg-lais-bg-soft disabled:cursor-not-allowed disabled:opacity-50"
        :disabled="page >= totalPages"
        @click="emit('changePage', page + 1)"
      >
        {{ t('POST_SALE.PAGINATION.NEXT') }}
      </button>
    </div>
  </div>
</template>
